/** @jsx jsx */
import { jsx, useThemeUI } from 'theme-ui'
import React from 'react'
import { get, isFunction, compact } from 'lodash'
import { graphql } from 'gatsby'

import Credits from '../credits'
import Introduction from '../introduction'
import { InlineHeader } from '../page-header'
import PageWrapper from '../page-wrapper'
import ProductionBlocks from '../production-blocks'
import Section from '../section'
import Title from '../title'
import CenterCol from '../center-col'
import LongForm from '../long-form'
import Signposts, { mapSignpost } from '../signposts'
import CallToAction from '../call-to-action'
import { NewsCardSection, VideosCardSection } from '../card-section'

import {
  Cont,
  TextBlock,
  FlexCols,
  FlexCol,
  Space,
  FlexColEmpty,
} from '../../styles/els'

import {
  formatImage,
  renderHTML,
  formatDate,
  resolveButtons,
} from '../../lib/helpers'
import { FullsizeImage, InlineImage } from '../../lib/fragments'

import { setValue, useThemeUISetValue } from '../../styles/utils'

const mapToCTA = (cta) => {
  const { text, image, buttons: _buttons } = cta

  return {
    heading: 'Get involved',
    text,
    buttons: resolveButtons(_buttons),
    image: image ? formatImage(image) : null,
    display: 'block',
  }
}

const PostPage = (props) => {
  const {
    pageColor,
    headerImage,
    headerVideo,
    title,
    sub,
    introduction,
    longFormContent,
    callToAction,
    signpost,
    relatedCards,
    children,
  } = props

  const hasLongFormContent = longFormContent && longFormContent.length > 0

  const { theme } = useThemeUI()
  const pT = useThemeUISetValue('sectionPadding', theme)

  return (
    <PageWrapper>
      <InlineHeader
        image={headerImage ? headerImage : null}
        video={headerVideo ? headerVideo : null}
      />
      <Section sx={{ pt: pT, pb: hasLongFormContent ? [5, 6] : null }}>
        <CenterCol span={6}>
          <Title title={title} sub={sub} subLower={true} color={pageColor} />
          {introduction ? (
            <div sx={{ variant: 'textBlock.25' }}>
              {renderHTML(introduction)}
            </div>
          ) : null}
        </CenterCol>
      </Section>
      {hasLongFormContent ? <LongForm blocks={longFormContent} /> : null}
      {callToAction ? (
        <CallToAction {...callToAction} pageColor={pageColor} />
      ) : null}
      {relatedCards && relatedCards.type === 'videos' ? (
        <VideosCardSection
          heading="Continue watching"
          toFilter={relatedCards.currentId}
          inset={true}
        />
      ) : relatedCards && relatedCards.type == 'news' ? (
        <NewsCardSection
          heading="Continue reading"
          toFilter={relatedCards.currentId}
          inset={true}
        />
      ) : null}
      {signpost ? <Signposts signposts={[signpost]} /> : null}
    </PageWrapper>
  )
}

export default PostPage
